import { useState } from 'react';
import { HiChevronDown as ChevronDownIcon } from 'react-icons/hi2';

import { type MultipleChoiceField } from '@/components/data-table/display/fields/Field';
import { type FieldRenderProps } from '@/components/data-table/display/fields/FieldRender';
import { MultipleChoiceEdit } from '@/components/data-table/display/fields/multiple-choice/MultipleChoiceEdit';

export function MultipleChoiceRender(props: FieldRenderProps<MultipleChoiceField>) {
  const { isFloating, value } = props;

  const [showOptionsIcon, setShowOptionsIcon] = useState(false);

  if (isFloating) {
    return <MultipleChoiceEdit {...props} />;
  }

  return (
    <div
      className="flex size-full justify-between p-2 text-right"
      onMouseEnter={() => {
        setShowOptionsIcon(true);
      }}
      onMouseLeave={() => {
        setShowOptionsIcon(false);
      }}
    >
      <p className="truncate" dangerouslySetInnerHTML={{ __html: value }} />
      {showOptionsIcon && (
        <ChevronDownIcon size={16} className="ml-auto p-2" data-testid="multiple-choice-icon" />
      )}
    </div>
  );
}
